import * as API from "middleware/api";

export const getFormRequest = () => API.executeWithAccessToken("/rapipago.company.prepaid.search");

export const preparePay = (params) => API.executeWithAccessToken("/rapipago.prepare.pay", { ...params });

export const payService = (params) => API.executeWithAccessToken("/rapipago.operation.confirm", { ...params });
